/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import makeMutationHook from 'core/types/makeMutationHook'
import makeQueryHook from 'core/types/makeQueryHook'
import * as operations from 'core/types/operations'

export const useListTemplateDescriptors = makeQueryHook(
  operations.listTemplateDescriptors,
)

export const useCreateTemplateDescriptor = makeMutationHook(
  operations.createTemplateDescriptor,
)

export const useGetTemplateDescriptor = makeQueryHook(
  operations.getTemplateDescriptor,
)

export const useUpdateTemplateDescriptor = makeMutationHook(
  operations.updateTemplateDescriptor,
)

export const useDeleteTemplateDescriptor = makeMutationHook(
  operations.deleteTemplateDescriptor,
)

export const useListTemplateVersionsByDescriptor = makeQueryHook(
  operations.listTemplateVersionsByDescriptor,
)

export const useListTemplateVersions = makeQueryHook(
  operations.listTemplateVersions,
)

export const useCreateTemplateVersion = makeMutationHook(
  operations.createTemplateVersion,
)

export const useListTemplateVersionsModern = makeQueryHook(
  operations.listTemplateVersionsModern,
)

export const useGetTemplateVersion = makeQueryHook(
  operations.getTemplateVersion,
)

export const useUpdateTemplateVersion = makeMutationHook(
  operations.updateTemplateVersion,
)

export const useDeleteTemplateVersion = makeMutationHook(
  operations.deleteTemplateVersion,
)

export const useActivateTemplateVersion = makeMutationHook(
  operations.activateTemplateVersion,
)

export const usePreviewTemplateVersion = makeMutationHook(
  operations.previewTemplateVersion,
)

export const useRenderTemplateVersion = makeMutationHook(
  operations.renderTemplateVersion,
)

export const useGetTemplateVars = makeQueryHook(operations.getTemplateVars)

export const useExportTemplates = makeQueryHook(operations.exportTemplates)

export const useImportTemplates = makeMutationHook(operations.importTemplates)

export const useHandleSend = makeMutationHook(operations.handleSend)

export const useHandleReceive = makeMutationHook(operations.handleReceive)

export const useResend = makeMutationHook(operations.resend)

export const useRender = makeMutationHook(operations.render)

export const useRenderToDocument = makeMutationHook(operations.renderToDocument)

export const usePreview = makeMutationHook(operations.preview)

export const useSendFreeFormEmail = makeMutationHook(
  operations.sendFreeFormEmail,
)

export const usePreviewFreeFormEmail = makeMutationHook(
  operations.previewFreeFormEmail,
)

export const useSendConfirmationCode = makeMutationHook(
  operations.sendConfirmationCode,
)

export const useSubjectDescriptorsList = makeQueryHook(
  operations.subjectDescriptorsList,
)

export const useSubjectDescriptorGetBySubject = makeQueryHook(
  operations.subjectDescriptorGetBySubject,
)

export const useSubjectDescriptorUpdate = makeMutationHook(
  operations.subjectDescriptorUpdate,
)

export const useInternalListTemplateDescriptors = makeQueryHook(
  operations.internalListTemplateDescriptors,
)

export const useInternalCreateTemplateDescriptor = makeMutationHook(
  operations.internalCreateTemplateDescriptor,
)

export const useBulkUpdateTemplateDescriptors = makeMutationHook(
  operations.bulkUpdateTemplateDescriptors,
)

export const useInternalGetTemplateDescriptor = makeQueryHook(
  operations.internalGetTemplateDescriptor,
)

export const useInternalUpdateTemplateDescriptor = makeMutationHook(
  operations.internalUpdateTemplateDescriptor,
)

export const useInternalDeleteTemplateDescriptor = makeMutationHook(
  operations.internalDeleteTemplateDescriptor,
)

export const useInternalListTemplateVersionsByDescriptor = makeQueryHook(
  operations.internalListTemplateVersionsByDescriptor,
)

export const useInternalListTemplateVersions = makeQueryHook(
  operations.internalListTemplateVersions,
)

export const useInternalCreateTemplateVersion = makeMutationHook(
  operations.internalCreateTemplateVersion,
)

export const useInternalListTemplateVersionsModern = makeQueryHook(
  operations.internalListTemplateVersionsModern,
)

export const useInternalGetTemplateVersion = makeQueryHook(
  operations.internalGetTemplateVersion,
)

export const useInternalUpdateTemplateVersion = makeMutationHook(
  operations.internalUpdateTemplateVersion,
)

export const useInternalDeleteTemplateVersion = makeMutationHook(
  operations.internalDeleteTemplateVersion,
)

export const useInternalActivateTemplateVersion = makeMutationHook(
  operations.internalActivateTemplateVersion,
)

export const useInternalExportTemplates = makeQueryHook(
  operations.internalExportTemplates,
)

export const useInternalImportTemplates = makeMutationHook(
  operations.internalImportTemplates,
)

export const useInternalConditionalImportTemplates = makeMutationHook(
  operations.internalConditionalImportTemplates,
)

export const useInternalHandleSend = makeMutationHook(
  operations.internalHandleSend,
)

export const useSendTemplatedEmailHandler = makeMutationHook(
  operations.sendTemplatedEmailHandler,
)

export const useInternalHandleReceive = makeMutationHook(
  operations.internalHandleReceive,
)

export const useInternalRender = makeMutationHook(operations.internalRender)

export const useInternalRenderToDocument = makeMutationHook(
  operations.internalRenderToDocument,
)

export const useInternalSubjectDescriptorsList = makeQueryHook(
  operations.internalSubjectDescriptorsList,
)

export const useInternalSubjectDescriptorGetBySubject = makeQueryHook(
  operations.internalSubjectDescriptorGetBySubject,
)

export const useInternalSubjectDescriptorUpdate = makeMutationHook(
  operations.internalSubjectDescriptorUpdate,
)
